import { gql } from '@grandvisionhq/graphql';
import { commercialCategoryFragment, frameFeaturesFragment, lensFeaturesFragment } from './fragments/small-fragments.js';
import './fragments/prices/productPriceItem.js';
import './fragments/prices/productPrice.js';
import { offeringsFragment } from './fragments/offerings.js';
import { productFragment } from './fragments/product.js';
import { variantFragment } from './fragments/variant.js';

const GET_FRAMES_BY_SLUG = gql`
  query GetFramesBySlug($slug: String!, $facets: [SearchFacetInput!]!) {
    getProductBySlug(slug: $slug, facets: $facets) {
      product {
        __typename
        ... on FrameProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          productTypeDetails {
            isOfferedWithPrescriptions
            lensDetails
            lensExtras
            offerings {
              ...offeringsFragment
            }
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              isReservable
              isInsuranceReimbursable
              brandModelCode
              brandModelColorCode
              channelAvailability
              trend
              segment
              targetGender
              targetGenderAllLocales {
                locale
                value
              }
              faceShape {
                shape
              }
              isVtoEnabled
              frameFeatures {
                ...frameFeaturesFragment
              }
              lensFeatures {
                ...lensFeaturesFragment
              }
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
  ${offeringsFragment}
  ${frameFeaturesFragment}
  ${lensFeaturesFragment}
`;

export { GET_FRAMES_BY_SLUG };
//# sourceMappingURL=get-frames-by-slug.js.map
